import {
  AlertCaption,
  TextAreaGroupPropsType,
  useSwitchAlertIcon,
} from "@/lib/main";
import Label from "./Label";
import TextArea from "./TextArea";

export default function TextAreaGroup({
  label,

  name,
  maxLength,
  cols,
  rows,
  placeholder,
  value,
  setValue,
  valueValid,
  required,
  textAreaRef,
  textAreaKeyDown,

  message,
  alertColor,

  fullWidth,
}: TextAreaGroupPropsType) {
  if (!alertColor) alertColor = "assist";
  const alertIcon = useSwitchAlertIcon(alertColor);

  return (
    <Label label={label} fullWidth={fullWidth}>
      <TextArea
        name={name}
        maxLength={maxLength}
        cols={cols}
        rows={rows}
        placeholder={placeholder}
        value={value}
        setValue={setValue}
        valueValid={valueValid}
        required={required}
        textAreaRef={textAreaRef}
        textAreaKeyDown={textAreaKeyDown}
        fullWidth={fullWidth}
      />

      {message ? (
        <AlertCaption color={alertColor} icon={alertIcon}>
          {message}
        </AlertCaption>
      ) : null}
    </Label>
  );
}
